import { apiQuestions } from '@/lib';
import { useQuery } from 'react-query';

interface useGetPatientQuestionResponsesProps {
  patientId: string;
  publicacaoId: string;
}

const useGetUsuarioResultadoQuiz = ({
  patientId,
  publicacaoId,
}: useGetPatientQuestionResponsesProps) => {
  const { data, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['patient-quizz-disparos', patientId, publicacaoId],
    queryFn: async () => {
      const res = await apiQuestions.get(
        `publicacao/resultado-by-user?userId=${patientId}&publicacaoId=${publicacaoId}`,
      );

      return res.data;
      // return [
      //   {
      //     sessaoId: '00000000-0000-0000-0000-000000000000',
      //     resultados: [
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '00000000-0000-0000-0000-000000000000',
      //         disparoId: '0b180fb6-830e-4a88-b70d-aa1d19d0a90b',
      //         indicadorId: 493,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 147,
      //           minimo: 0,
      //           operadorMinimo: 3,
      //           maximo: 3,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'sintomas mínimos',
      //           feedBack: 'sintomas mínimos',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: '2026-03-09T11:16:03.869724',
      //           lastModifierId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           creationTime: '2026-03-09T11:15:41.2136647',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 493,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-11T11:21:18.1182061',
      //         creatorId: null,
      //         id: 2122,
      //       },
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '00000000-0000-0000-0000-000000000000',
      //         disparoId: '68c49782-fe6a-421b-b8e0-457c1bce7fe6',
      //         indicadorId: 497,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 148,
      //           minimo: 0,
      //           operadorMinimo: 1,
      //           maximo: 2,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'adesão alta ao tratamento',
      //           feedBack: 'adesão alta ao tratamento',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: null,
      //           lastModifierId: null,
      //           creationTime: '2026-03-09T11:25:24.6448116',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 497,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-11T11:21:32.9291004',
      //         creatorId: null,
      //         id: 2123,
      //       },
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '00000000-0000-0000-0000-000000000000',
      //         disparoId: '71e590ff-fb19-4f4c-9a69-154b65eca863',
      //         indicadorId: 501,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 149,
      //           minimo: 0,
      //           operadorMinimo: 1,
      //           maximo: 3,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'sono adequado',
      //           feedBack: 'sono adequado',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: null,
      //           lastModifierId: null,
      //           creationTime: '2026-03-09T11:27:38.0068545',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 501,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-11T11:21:43.8560099',
      //         creatorId: null,
      //         id: 2124,
      //       },
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '00000000-0000-0000-0000-000000000000',
      //         disparoId: 'd2618f93-7525-4674-8f7d-f8278af3750d',
      //         indicadorId: 505,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 150,
      //           minimo: 0,
      //           operadorMinimo: 1,
      //           maximo: 3,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'bem-estar emocional adequado',
      //           feedBack: 'bem-estar emocional adequado',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: null,
      //           lastModifierId: null,
      //           creationTime: '2026-03-09T11:29:25.7546216',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 505,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-11T11:21:55.0612153',
      //         creatorId: null,
      //         id: 2125,
      //       },
      //     ],
      //   },
      //   {
      //     sessaoId: '61054329-ef0f-4959-9b64-a5d93b40ec5d',
      //     resultados: [
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '61054329-ef0f-4959-9b64-a5d93b40ec5d',
      //         disparoId: 'ddecc2da-1b22-483b-9a50-1e3e771fc1c0',
      //         indicadorId: 493,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 147,
      //           minimo: 0,
      //           operadorMinimo: 3,
      //           maximo: 3,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'sintomas mínimos',
      //           feedBack: 'sintomas mínimos',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: '2026-03-09T11:16:03.869724',
      //           lastModifierId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           creationTime: '2026-03-09T11:15:41.2136647',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 493,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-13T16:55:17.116808',
      //         creatorId: null,
      //         id: 2152,
      //       },
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '61054329-ef0f-4959-9b64-a5d93b40ec5d',
      //         disparoId: 'ce9511b8-6f5c-4b09-8525-5e5b7669139b',
      //         indicadorId: 497,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 148,
      //           minimo: 0,
      //           operadorMinimo: 1,
      //           maximo: 2,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'adesão alta ao tratamento',
      //           feedBack: 'adesão alta ao tratamento',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: null,
      //           lastModifierId: null,
      //           creationTime: '2026-03-09T11:25:24.6448116',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 497,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-13T16:55:32.412391',
      //         creatorId: null,
      //         id: 2153,
      //       },
      //     ],
      //   },
      //   {
      //     sessaoId: '7fe954b0-b20c-459e-bce4-32235b5e07ba',
      //     resultados: [
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '7fe954b0-b20c-459e-bce4-32235b5e07ba',
      //         disparoId: 'b08ef44f-a06e-4835-a15e-cb6f81259d44',
      //         indicadorId: 493,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 147,
      //           minimo: 0,
      //           operadorMinimo: 3,
      //           maximo: 3,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'sintomas mínimos',
      //           feedBack: 'sintomas mínimos',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: '2026-03-09T11:16:03.869724',
      //           lastModifierId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           creationTime: '2026-03-09T11:15:41.2136647',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 493,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-13T16:56:11.643689',
      //         creatorId: null,
      //         id: 2154,
      //       },
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '7fe954b0-b20c-459e-bce4-32235b5e07ba',
      //         disparoId: 'aa529348-6f69-41b0-91d3-e0d1bda469e9',
      //         indicadorId: 497,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 148,
      //           minimo: 0,
      //           operadorMinimo: 1,
      //           maximo: 2,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'adesão alta ao tratamento',
      //           feedBack: 'adesão alta ao tratamento',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: null,
      //           lastModifierId: null,
      //           creationTime: '2026-03-09T11:25:24.6448116',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 497,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-13T16:56:25.903475',
      //         creatorId: null,
      //         id: 2155,
      //       },
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '7fe954b0-b20c-459e-bce4-32235b5e07ba',
      //         disparoId: '7431e133-2525-459f-a5bb-ee6a5764421d',
      //         indicadorId: 501,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 149,
      //           minimo: 0,
      //           operadorMinimo: 1,
      //           maximo: 3,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'sono adequado',
      //           feedBack: 'sono adequado',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: null,
      //           lastModifierId: null,
      //           creationTime: '2026-03-09T11:27:38.0068545',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 501,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-13T16:56:41.274069',
      //         creatorId: null,
      //         id: 2156,
      //       },
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '7fe954b0-b20c-459e-bce4-32235b5e07ba',
      //         disparoId: 'f0bd624e-fa24-4f1f-974f-c5545c8cb689',
      //         indicadorId: 505,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 150,
      //           minimo: 0,
      //           operadorMinimo: 1,
      //           maximo: 3,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'bem-estar emocional adequado',
      //           feedBack: 'bem-estar emocional adequado',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: null,
      //           lastModifierId: null,
      //           creationTime: '2026-03-09T11:29:25.7546216',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 505,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-13T16:56:58.285061',
      //         creatorId: null,
      //         id: 2157,
      //       },
      //     ],
      //   },
      //   {
      //     sessaoId: '86cdb678-51dd-4fb5-9c73-a19f26eed124',
      //     resultados: [
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '86cdb678-51dd-4fb5-9c73-a19f26eed124',
      //         disparoId: 'b1209e3c-4320-4c65-b0e8-fb4e511dd04d',
      //         indicadorId: 493,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 147,
      //           minimo: 0,
      //           operadorMinimo: 3,
      //           maximo: 3,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'sintomas mínimos',
      //           feedBack: 'sintomas mínimos',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: '2026-03-09T11:16:03.869724',
      //           lastModifierId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           creationTime: '2026-03-09T11:15:41.2136647',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 493,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-13T16:51:38.588349',
      //         creatorId: null,
      //         id: 2148,
      //       },
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '86cdb678-51dd-4fb5-9c73-a19f26eed124',
      //         disparoId: 'd28091c9-a818-4a78-a3a4-4d0224f162b2',
      //         indicadorId: 497,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 148,
      //           minimo: 0,
      //           operadorMinimo: 1,
      //           maximo: 2,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'adesão alta ao tratamento',
      //           feedBack: 'adesão alta ao tratamento',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: null,
      //           lastModifierId: null,
      //           creationTime: '2026-03-09T11:25:24.6448116',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 497,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-13T16:52:15.02757',
      //         creatorId: null,
      //         id: 2149,
      //       },
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '86cdb678-51dd-4fb5-9c73-a19f26eed124',
      //         disparoId: '3070ab99-76bf-4cca-9abe-b38cf4a4a6b4',
      //         indicadorId: 501,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 149,
      //           minimo: 0,
      //           operadorMinimo: 1,
      //           maximo: 3,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'sono adequado',
      //           feedBack: 'sono adequado',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: null,
      //           lastModifierId: null,
      //           creationTime: '2026-03-09T11:27:38.0068545',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 501,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-13T16:52:49.859648',
      //         creatorId: null,
      //         id: 2150,
      //       },
      //       {
      //         publicacaoId: 300,
      //         userId: '72a58658-8a35-4414-e6d1-08de5cd06bd5',
      //         sessaoId: '86cdb678-51dd-4fb5-9c73-a19f26eed124',
      //         disparoId: '81f58ef8-27d5-4be4-98e1-b5544e2ff3ea',
      //         indicadorId: 505,
      //         indicador: {
      //           rotulo: 'Saúde Emocional e Risco de Ansiedade (GAD-7)',
      //           grupoIndicadorId: 150,
      //           minimo: 0,
      //           operadorMinimo: 1,
      //           maximo: 3,
      //           operadorMaximo: 2,
      //           corAlerta: 0,
      //           indicadorProfissional: 'bem-estar emocional adequado',
      //           feedBack: 'bem-estar emocional adequado',
      //           grupoIndicador: null,
      //           score: null,
      //           lastModificationTime: null,
      //           lastModifierId: null,
      //           creationTime: '2026-03-09T11:29:25.7546216',
      //           creatorId: 'c729e5f9-8c96-7cb1-40e7-3a192412c63c',
      //           id: 505,
      //         },
      //         protocoloId: null,
      //         isDeleted: false,
      //         deleterId: null,
      //         deletionTime: null,
      //         lastModificationTime: null,
      //         lastModifierId: null,
      //         creationTime: '2026-03-13T16:53:06.353772',
      //         creatorId: null,
      //         id: 2151,
      //       },
      //     ],
      //   },
      // ];
    },
    enabled: !!patientId && !!publicacaoId,
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
};

export default useGetUsuarioResultadoQuiz;
